import { FC } from 'react';
import EcoBenefits from '../Teaser/EcoBenefits';
import CelebratingUs from './CelebratingUs';
import ReferralNext from './ReferralNextEnd';
import Subscribe from './SubscribeEnd';
import Nav from './Nav';

const EndCompoment: FC = ({}) => {
    return (
        <div className="page-end">
            <div className="members-day-over"></div>
            <Nav />
            <CelebratingUs />
            <div className="members-day-over"></div>
            <Subscribe />
            <div className="members-day-over"></div>
            <EcoBenefits cls="end" />
            <ReferralNext />
            <div className="members-day-over"></div>
        </div>
    );
};

export default EndCompoment;
